/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import { IModelSpec } from "../../shared/IModelSpec";
import { Model_FPI_MSP_2020_05_Component } from "./Model_FPI_MSP_2020_05_Component";
import { Model_FPI_MSP_2020_05_Handler } from "./Model_FPI_MSP_2020_05_Handler";

export const Model_FPI_MSP_2020_05_Spec = {
	id: "fpi-msp-2020-08",
	icon: "finance",
	title: "IFV pro MSP",
	titleLong: "Indikátory finanční výkonnosti pro malé a střední podniky.",
	description: "Finanční analýza a odhad EVA Equity.",
	version: "2020/08",
	component: Model_FPI_MSP_2020_05_Component,
	handlerFactory: Model_FPI_MSP_2020_05_Handler
} as IModelSpec;
